import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { postMaterialDeclaration, postMaterialDeclarationRemarks } from "../Actions/MaterialDeclarationAPI";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import { getCompanyList, getSDOcCompanyList } from "../Actions/MDlistingAPI";
import Autocomplete from 'react-autocomplete';
import { updateCollectMDocSDoc } from "../Actions/MMPLDashboardAPI";
import { UploadMDoc, UploadSDoc } from "../Actions/CommonAPI";
import * as moment from 'moment';


var today = new Date();
var currentDate = moment(today).format("DD MMM YYYY");
var currentDateForAPI = moment(today).format("YYYY-MM-DD");

let user = JSON.parse(localStorage.getItem("currentUser"));

class MaterialDeclarationCollect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            declarationDetails: {
                materialDeclarationId: 0,
                mDremaks1Id: 0,
                mDremaks2Id: 0,
                mDremaks3Id: 0,
                mdAttachmentId: 0,
                isCollectMDSDOC: true,
                poLineItemId: null,
                sDocAttachmentId: 0,
                dateOfDeclaration: currentDateForAPI,
                mdidNo: "",
                companyName: "",
                divisionName: "",
                address: "",
                telephone: "",
                fax: "",
                email: "",
                sdocIdNo: "",
                productNumber: "",
                productName: "",
                productInfo: "",
                contactPerson: "",
                productQuantityAmount: 0,
                productMetricUnit: "",
                materialQuantityAmount: 0,
                materialMetricUnit: "",
                remarks1: "",
                remarks2: "",
                remarks3: "",
                mdAttachmentName: "",
                mdAttachmentGuid: "",
                sDocAttachmentName: "",
                sDocAttachmentGuid: "",
                materials: [
                    { "mDmaterialsId": 0, "materialName": "Asbestos", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Polychlorinated biphenyls (PCBs)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Chlorofluorocarbons (CFCs)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Halons", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Other fully halogenated CFCs", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Carbon tetrachloride", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "1,1,1-Trichloroethane", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Hydrochlorofluorocarbons", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Hydrobromofluorocarbons", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Methyl bromide", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Bromochloromethane", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Anti-fouling systems containing organotin compounds as a biocide", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Cadmium and cadmium compounds", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Hexavalent chromium and hexavalent chromium compounds", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Lead and lead compounds", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Mercury and mercury compounds", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Polybrominated biphenyl (PBBs)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Polybrominated dephenyl ethers (PBDEs)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Polychloronaphthalenes (CI >= 3)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Radioactive substances", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Certain shortchain chlorinated paraffins", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Perfluorooctane sulfonic acid (PFOs)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" },
                    { "mDmaterialsId": 0, "materialName": "Brominated Flame Retardant (HBCDD)", "isContainAboveThreshold": false, "mass": "", "unit": "", "informationOnUsage": "" }
                ],
                createdBy: user.email,
                modifiedBy: user.email,
                createdDate: currentDate,
                modifiedDate: currentDate,
                isInPoValidation: false
            },
            EquipmentList: [],
            ihmPresenseYes: true,
            ihmPresenseNo: false,
            mdocfile: "",
            sdocfile: "",
            MDocFilename: "",
            SDocFilename: "",
            CollectMdocSdoc: {
                shipId: 0,
                purchaseOrderId: 0,
                poLineItemId: 1,
                ihmPresence: true,
                mdocAttachmentId: "",
                mdocAttachmentName: "",
                mdocAttachmentGuid: "",
                sdocAttachmentId: "",
                sdocAttachmentName: "",
                sdocAttachmentGuid: "",
                modifiedBy: user.email
            }
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMaterialInputChange = this.handleMaterialInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChanges = this.handleInputChanges.bind(this);
        this.renderMovieTitle = this.renderMovieTitle.bind(this);

    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({ type: 'SubBannerTitle', data: "Material Declaration" });
        dispatch(getCompanyList());
        dispatch(getSDOcCompanyList());
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { match, MDocAttachment, SDocAttachment, PODetail, history, CompanyList } = nextProps;
        const { params } = match;
        const { lineItemId } = params;
        if (MDocAttachment) {
            prevState.declarationDetails.mdAttachmentName = MDocAttachment.FileName;
            prevState.declarationDetails.mdAttachmentGuid = MDocAttachment.Guid;
            prevState.mdocfile = '';
        }

        if (SDocAttachment) {
            prevState.declarationDetails.sDocAttachmentName = SDocAttachment.FileName;
            prevState.declarationDetails.sDocAttachmentGuid = SDocAttachment.Guid;
            prevState.sdocfile = '';
        }

        if (lineItemId) {
            prevState.declarationDetails.poLineItemId = parseInt(lineItemId);
        } else {
            prevState.declarationDetails.poLineItemId = 0;
        }

        if (CompanyList) {
            prevState.EquipmentList = CompanyList.companyNames
        }

        if (!PODetail) {
            history.goBack();
        }
    }

    AddMaterialDeclaration() {
        const { dispatch, MDSDocCollectAll, PODetail, isInPoValidation } = this.props;
        const { declarationDetails } = this.state;
        if (isInPoValidation) {
            this.state.declarationDetails.isInPoValidation = true
            this.state.declarationDetails['purchaseOrderId'] = PODetail.purchaseOrderId;
            console.log('declarationDetails', declarationDetails);

            let url1 = `${API.PostMD}`;
            let data = {
                dateOfDeclaration: declarationDetails.dateOfDeclaration,
                mdidNo: declarationDetails.mdidNo,
                companyName: declarationDetails.companyName,
                divisionName: declarationDetails.divisionName,
                address: declarationDetails.address,
                telephone: declarationDetails.telephone,
                fax: declarationDetails.fax,
                email: declarationDetails.email,
                sdocIdNo: declarationDetails.sdocIdNo,
                productNumber: declarationDetails.productNumber,
                productName: declarationDetails.productName,
                productInfo: declarationDetails.productInfo,
                contactPerson: declarationDetails.contactPerson,
                productQuantityAmount: declarationDetails.productQuantityAmount,
                productMetricUnit: declarationDetails.productMetricUnit,
                materialQuantityAmount: declarationDetails.materialQuantityAmount,
                materialMetricUnit: declarationDetails.materialMetricUnit,
                mdAttachmentName: declarationDetails.mdAttachmentName,
                mdAttachmentGuid: declarationDetails.mdAttachmentGuid,
                sDocAttachmentId: declarationDetails.sDocAttachmentId,
                // sDocAttachmentName: declarationDetails.sDocAttachmentName,
                // sDocAttachmentGuid: declarationDetails.sDocAttachmentGuid,
                createdBy: declarationDetails.createdBy
            }
            axios.post(url1, data)
                .then((response) => {

                    declarationDetails.materialDeclarationId = response.data;
                    this.setState({});
                    let uri = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${response.data}`;
                    axios.get(uri)
                        .then((res) => {
                            if (res.data) {
                                declarationDetails.mdAttachmentId = res.data.mdAttachmentId;
                                // declarationDetails.sDocAttachmentId = res.data.sDocAttachmentId;
                                this.setState({});
                                let url2 = `${API.PostMDMAterials}`;
                                let data1 = {
                                    materialDeclarationId: declarationDetails.materialDeclarationId,
                                    materials: declarationDetails.materials,
                                    createdBy: declarationDetails.createdBy

                                }
                                axios.post(url2, data1)
                                    .then((response) => {
                                        if (response.data) {
                                            let url3 = `${API.PostMDRemarks}`;
                                            let data2 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                remarks1: declarationDetails.remarks1,
                                                remarks2: declarationDetails.remarks2,
                                                remarks3: declarationDetails.remarks3,
                                                createdBy: declarationDetails.createdBy

                                            }
                                            axios.post(url3, data2)
                                                .then((response) => {
                                                    dispatch({ type: "PostMDRemarksSuccess", data: response.data });
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMDRemarksFailure",
                                                        error: "ERROR"
                                                    })
                                                })
                                            let url4 = `${API.BulkUpdateMDSDoc}`;
                                            let data3 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                purchaseOrderId: declarationDetails.purchaseOrderId,
                                                poLineItemId: declarationDetails.poLineItemId,
                                                sDocAttachmentId: declarationDetails.sDocAttachmentId,
                                                mdAttachmentId: declarationDetails.mdAttachmentId,
                                                isCollectMDSDOC: declarationDetails.isCollectMDSDOC,
                                                isInPoValidation: declarationDetails.isInPoValidation,
                                                isContainAboveThreshold: declarationDetails.isContainAboveThreshold,
                                                createdBy: declarationDetails.createdBy
                                            }
                                            axios.post(url4, data3)
                                                .then((response) => {
                                                    dispatch({ type: "PostMaterialDeclarationSuccess", data: response.data });
                                                    this.props.history.goBack();
                                                    toast.success(' Material Declaration submitted successfully.', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                    });
                                                    // this.props.history.push("/Home/MDLibrary");
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMaterialDeclarationFailure",
                                                        error: "ERROR"
                                                    })
                                                })
                                            dispatch({ type: "AttachmentUploadMDocSuccess", data: null });
                                            dispatch({ type: "AttachmentUploadSDocSuccess", data: null });
                                        }
                                        dispatch({ type: "PostMDMAterialsSuccess", data: response.data });
                                    })
                                    .catch((error) => {
                                        dispatch({
                                            type: "PostMDMAterialsFailure",
                                            error: "ERROR"
                                        })
                                    });
                            }
                            dispatch({
                                type: "GetMaterialDeclarationIdSuccess",
                                data: res.data,
                            })
                        })
                        .catch((error) => {
                            dispatch({
                                type: "GetMaterialDeclarationIdFailure",
                                error: "ERROR"
                            })
                        });
                    dispatch({ type: "PostMDSuccess", data: response.data });
                })
                .catch((error) => {
                    dispatch({
                        type: "PostMDFailure",
                        error: "ERROR"
                    })
                })

        }
        else if (MDSDocCollectAll) {
            this.state.declarationDetails['purchaseOrderId'] = PODetail.purchaseOrderId;
            console.log('declarationDetails', declarationDetails);

            let url1 = `${API.PostMD}`;
            let data = {
                dateOfDeclaration: declarationDetails.dateOfDeclaration,
                mdidNo: declarationDetails.mdidNo,
                companyName: declarationDetails.companyName,
                divisionName: declarationDetails.divisionName,
                address: declarationDetails.address,
                telephone: declarationDetails.telephone,
                fax: declarationDetails.fax,
                email: declarationDetails.email,
                sdocIdNo: declarationDetails.sdocIdNo,
                productNumber: declarationDetails.productNumber,
                productName: declarationDetails.productName,
                productInfo: declarationDetails.productInfo,
                contactPerson: declarationDetails.contactPerson,
                productQuantityAmount: declarationDetails.productQuantityAmount,
                productMetricUnit: declarationDetails.productMetricUnit,
                materialQuantityAmount: declarationDetails.materialQuantityAmount,
                materialMetricUnit: declarationDetails.materialMetricUnit,
                mdAttachmentName: declarationDetails.mdAttachmentName,
                mdAttachmentGuid: declarationDetails.mdAttachmentGuid,
                sdocAttachmentId: declarationDetails.sDocAttachmentId,
                // sDocAttachmentName: declarationDetails.sDocAttachmentName,
                // sDocAttachmentGuid: declarationDetails.sDocAttachmentGuid,
                createdBy: declarationDetails.createdBy
            }
            axios.post(url1, data)
                .then((response) => {
                    declarationDetails.materialDeclarationId = response.data;
                    this.setState({});
                    let uri = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${response.data}`;
                    axios.get(uri)
                        .then((res) => {
                            if (res.data) {
                                declarationDetails.mdAttachmentId = res.data.mdAttachmentId;
                                // declarationDetails.sDocAttachmentId = res.data.sDocAttachmentId;
                                this.setState({});

                                let url2 = `${API.PostMDMAterials}`;
                                let data1 = {
                                    materialDeclarationId: declarationDetails.materialDeclarationId,
                                    materials: declarationDetails.materials,
                                    createdBy: declarationDetails.createdBy

                                }
                                axios.post(url2, data1)
                                    .then((response) => {
                                        if (response.data) {
                                            let url3 = `${API.PostMDRemarks}`;
                                            let data2 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                remarks1: declarationDetails.remarks1,
                                                remarks2: declarationDetails.remarks2,
                                                remarks3: declarationDetails.remarks3,
                                                createdBy: declarationDetails.createdBy

                                            }
                                            axios.post(url3, data2)
                                                .then((response) => {
                                                    dispatch({ type: "PostMDRemarksSuccess", data: response.data });
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMDRemarksFailure",
                                                        error: "ERROR"
                                                    })
                                                })
                                            let url4 = `${API.BulkUpdateMDSDoc}`;
                                            let data3 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                purchaseOrderId: declarationDetails.purchaseOrderId,
                                                poLineItemId: declarationDetails.poLineItemId,
                                                sDocAttachmentId: declarationDetails.sDocAttachmentId,
                                                mdAttachmentId: declarationDetails.mdAttachmentId,
                                                isCollectMDSDOC: declarationDetails.isCollectMDSDOC,
                                                isInPoValidation: declarationDetails.isInPoValidation,
                                                isContainAboveThreshold: declarationDetails.isContainAboveThreshold,
                                                createdBy: declarationDetails.createdBy
                                            }
                                            axios.post(url4, data3)
                                                .then((response) => {
                                                    dispatch({ type: "PostMaterialDeclarationSuccess", data: response.data });
                                                    this.props.history.goBack();
                                                    toast.success(' Material Declaration submitted successfully.', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                    });
                                                    // this.props.history.push("/Home/MDLibrary");
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMaterialDeclarationFailure",
                                                        error: "ERROR"
                                                    })
                                                })
                                            // this.props.history.goBack();
                                            dispatch({ type: "AttachmentUploadMDocSuccess", data: null });
                                            dispatch({ type: "AttachmentUploadSDocSuccess", data: null });
                                        }
                                        dispatch({ type: "PostMDMAterialsSuccess", data: response.data });
                                    })
                                    .catch((error) => {
                                        dispatch({
                                            type: "PostMDMAterialsFailure",
                                            error: "ERROR"
                                        })
                                    });
                            }
                            dispatch({
                                type: "GetMaterialDeclarationIdSuccess",
                                data: res.data,
                            })
                        })
                        .catch((error) => {
                            dispatch({
                                type: "GetMaterialDeclarationIdFailure",
                                error: "ERROR"
                            })
                        });
                    dispatch({ type: "PostMDSuccess", data: response.data });
                })
                .catch((error) => {
                    dispatch({
                        type: "PostMDFailure",
                        error: "ERROR"
                    })
                })
        }
        else {
            this.state.declarationDetails['purchaseOrderId'] = PODetail.purchaseOrderId;
            let url1 = `${API.PostMD}`;
            let data = {
                dateOfDeclaration: declarationDetails.dateOfDeclaration,
                mdidNo: declarationDetails.mdidNo,
                companyName: declarationDetails.companyName,
                divisionName: declarationDetails.divisionName,
                address: declarationDetails.address,
                telephone: declarationDetails.telephone,
                fax: declarationDetails.fax,
                email: declarationDetails.email,
                sdocIdNo: declarationDetails.sdocIdNo,
                productNumber: declarationDetails.productNumber,
                productName: declarationDetails.productName,
                productInfo: declarationDetails.productInfo,
                contactPerson: declarationDetails.contactPerson,
                productQuantityAmount: declarationDetails.productQuantityAmount,
                productMetricUnit: declarationDetails.productMetricUnit,
                materialQuantityAmount: declarationDetails.materialQuantityAmount,
                materialMetricUnit: declarationDetails.materialMetricUnit,
                mdAttachmentName: declarationDetails.mdAttachmentName,
                mdAttachmentGuid: declarationDetails.mdAttachmentGuid,
                sdocAttachmentId: declarationDetails.sDocAttachmentId,
                // sDocAttachmentName: declarationDetails.sDocAttachmentName,
                // sDocAttachmentGuid: declarationDetails.sDocAttachmentGuid,
                createdBy: declarationDetails.createdBy
            }
            axios.post(url1, data)
                .then((response) => {
                    declarationDetails.materialDeclarationId = response.data;
                    this.setState({});
                    let uri = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${response.data}`;
                    axios.get(uri)
                        .then((res) => {
                            if (res.data) {
                                declarationDetails.mdAttachmentId = res.data.mdAttachmentId;
                                // declarationDetails.sDocAttachmentId = res.data.sDocAttachmentId;
                                this.setState({});

                                let url2 = `${API.PostMDMAterials}`;
                                let data1 = {
                                    materialDeclarationId: declarationDetails.materialDeclarationId,
                                    materials: declarationDetails.materials,
                                    createdBy: declarationDetails.createdBy

                                }
                                axios.post(url2, data1)
                                    .then((response) => {
                                        if (response.data) {
                                            let url3 = `${API.PostMDRemarks}`;
                                            let data2 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                remarks1: declarationDetails.remarks1,
                                                remarks2: declarationDetails.remarks2,
                                                remarks3: declarationDetails.remarks3,
                                                createdBy: declarationDetails.createdBy

                                            }
                                            axios.post(url3, data2)
                                                .then((response) => {
                                                    dispatch({ type: "PostMDRemarksSuccess", data: response.data });
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMDRemarksFailure",
                                                        error: "ERROR"
                                                    })
                                                })

                                            let url4 = `${API.PostMaterialDeclaration}`;
                                            let data3 = {
                                                materialDeclarationId: declarationDetails.materialDeclarationId,
                                                purchaseOrderId: declarationDetails.purchaseOrderId,
                                                poLineItemId: declarationDetails.poLineItemId,
                                                sDocAttachmentId: declarationDetails.sDocAttachmentId,
                                                mdAttachmentId: declarationDetails.mdAttachmentId,
                                                isCollectMDSDOC: declarationDetails.isCollectMDSDOC,
                                                isInPoValidation: declarationDetails.isInPoValidation,
                                                isContainAboveThreshold: declarationDetails.isContainAboveThreshold,
                                                createdBy: declarationDetails.createdBy
                                            }
                                            axios.post(url4, data3)
                                                .then((response) => {
                                                    dispatch({ type: "PostMaterialDeclarationSuccess", data: response.data });
                                                    // this.props.history.push("/Home/MDLibrary");
                                                    this.props.history.goBack();
                                                    toast.success(' Material Declaration submitted successfully.', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                    });
                                                })
                                                .catch((error) => {
                                                    dispatch({
                                                        type: "PostMaterialDeclarationFailure",
                                                        error: "ERROR"
                                                    })
                                                })
                                            // this.props.history.goBack();
                                            dispatch({ type: "AttachmentUploadMDocSuccess", data: null });
                                            dispatch({ type: "AttachmentUploadSDocSuccess", data: null });
                                        }
                                        dispatch({ type: "PostMDMAterialsSuccess", data: response.data });
                                    })
                                    .catch((error) => {
                                        dispatch({
                                            type: "PostMDMAterialsFailure",
                                            error: "ERROR"
                                        })
                                    });
                            }
                            dispatch({
                                type: "GetMaterialDeclarationIdSuccess",
                                data: res.data,
                            })
                        })
                        .catch((error) => {
                            dispatch({
                                type: "GetMaterialDeclarationIdFailure",
                                error: "ERROR"
                            })
                        });
                    dispatch({ type: "PostMDSuccess", data: response.data });
                })
                .catch((error) => {
                    dispatch({
                        type: "PostMDFailure",
                        error: "ERROR"
                    })
                })
        }
    }

    handleInputChange(e, field) {
        let nodeName = e.target.name;
        if (field === "productMetricUnit" || field === "materialMetricUnit") {
            this.state.declarationDetails[field] = e.target.value;
        }
        else {
            let value = e.target.textContent;
            if (field === "productQuantityAmount" || field === "materialQuantityAmount") {
                value = parseInt(value);
                this.state.declarationDetails[field] = value;
            }
            else {
                this.state.declarationDetails[field] = value;
            }

        }
        this.setState({});
    }

    handleMaterialInputChange(e, field, index) {
        const { declarationDetails } = this.state;
        if (field === "unit" || field === "isContainAboveThreshold") {
            let value = e.target.value;
            if (value === "true" || value === "false") {
                value = JSON.parse(value);
            }
            declarationDetails.materials[index][field] = value;
        } else {
            declarationDetails.materials[index][field] = e.target.textContent;
        }
        this.setState({ declarationDetails: declarationDetails });
    }

    CancelMaterialDeclaration() {
        this.props.history.goBack();
    }

    onHandleInputChange(e) {
        const { dispatch } = this.props;
        let nodeName = e.target.name;
        if (nodeName === "MDoc") {
            this.state.declarationDetails.mdAttachmentName = e.target.files[0].name;
            this.state.mdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadMDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadMDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        } else if (nodeName === "SDoc") {
            this.state.declarationDetails.sdocAttachmentName = e.target.files[0].name;
            this.state.sdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadSDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadSDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        }
    }

    onHandleRadioInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "ihmPresenseYes") {
            this.state.CollectMdocSdoc.ihmPresence = true;
            this.setState({
                ihmPresenseYes: true,
                ihmPresenseNo: false
            });
        } else if (nodeName === "ihmPresenseNo") {
            this.state.CollectMdocSdoc.ihmPresence = false;
            this.setState({
                ihmPresenseYes: false,
                ihmPresenseNo: true
            });
        }
    }

    handleInputChanges(e, field) {
        this.state.declarationDetails[field] = e.target.value;
        this.setState({});
    }

    handleSelectChange(value, field) {
        this.state.declarationDetails[field] = value;
        this.state.declarationDetails.sDocAttachmentName = "";
        this.setState({});
        this.props.dispatch(getSDOcCompanyList(value));
    }

    ClearMDoc() {
        let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "AttachmentUploadMDocSuccess",
            data: clearData,
        })
    }

    ClearSDoc() {
        let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "AttachmentUploadSDocSuccess",
            data: clearData,
        })
    }

    hideSidePanel = () => {
        this.props.history.goBack();
    }

    renderMovieTitle(state, val) {
        return (
            state.toLowerCase().indexOf(val.toLowerCase()) !== -1
        );
    }

    renderattachmentNameTitle = (state, val) => {
        return state?.attachmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    }

    handleAnnualSearchChange = (e) => {
        const { dispatch } = this.props;
        this.state.declarationDetails.sDocAttachmentName = e.target.value;
        this.setState({});
    };

    handleAnnualSelectChange = (e, item) => {
        const { dispatch } = this.props;
        this.state.declarationDetails.sDocAttachmentName = e;
        this.state.declarationDetails.sDocAttachmentId = item.attachmetId;
        this.setState({});
    };

    render() {
        const { PODetail, POLineItem, SDocCompanyList } = this.props;
        return (
            <div className="full-height px-4 py-3">
                <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" onClick={() => this.hideSidePanel()}>
                    &larr; Return
                </button>
                <div className="panel-box mb-3 mt-2">
                    {/* <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5 className="card-title ml-2 my-2" style={{ color: "092a51" }}>
                                        {POLineItem ? POLineItem.itemDescription : ""}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="px-4 py-2">
                        <div className="resource-list-auth-date">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        {POLineItem ? (
                                            <div className="col-md-12 py-1">
                                                <h6 className="resource-list-title m-auto">
                                                    {POLineItem ? POLineItem.itemDescription : ""}
                                                </h6>
                                            </div>
                                        ) : null}
                                        <div className="col-md-4 py-1">
                                            <span>
                                                <strong>PO No : </strong>
                                                <span className="italicFont ">{PODetail ? PODetail.poNo : ""}</span>
                                            </span>
                                        </div>
                                        <div className="col-md-4 py-1">
                                            <span>
                                                <strong>PR No : </strong>
                                                <span className="italicFont ">{PODetail ? PODetail.prNo : ""}</span>
                                            </span>
                                        </div>
                                        <div className="col-md-4 py-1">
                                            <span>
                                                <strong>PO Date : </strong>
                                                <span className="italicFont">{PODetail ? moment(new Date(Date.parse(PODetail.poDate))).format('DD MMM YYYY') : ""}</span>
                                            </span>
                                        </div>
                                        <div className="col-md-12 py-1">
                                            <span>
                                                <strong>PO Description : </strong>
                                                <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                            </span>
                                        </div>
                                        <div className="col-md-12 py-1">
                                            <span>
                                                <strong>Ship Name : </strong>
                                                <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card MM-card-header m-auto">
                    <div className="card-body">
                        <h5 className="card-title ml-2 mt-2">Material Declaration</h5>
                    </div>
                </div>
                <div className="panel-box p-3">
                    <div className="row">
                        {/* Date Declaration Table */}
                        <div className="col-lg-6">
                            <h5><b>Date of Declaration</b></h5>
                            <table className="material-decalaration-table">
                                <tr>
                                    <th>Date</th>
                                    <td contentEditable="false" onBlur={(e) => this.handleInputChange(e, "dateOfDeclaration")}>{currentDate}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    {/*MD ID number Table */}
                    <div className="row mt-3">
                        <div className="col-lg-6">
                            <h5><b>MD ID Number</b></h5>
                            <table className="material-decalaration-table">
                                <tr>
                                    <th>MD-ID-No.</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "mdidNo")}>{this.state.declarationDetails.mdidNo}
                                    </td>
                                </tr>
                            </table>
                            {/*Other information Table */}
                            <h5 className="mt-3"><b>Other Information</b></h5>
                            <table className="material-decalaration-table mb-3">
                                <tr>
                                    <th>Remark 1</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "remarks1")}>{this.state.declarationDetails.remarks1}</td>
                                </tr>
                                <tr>
                                    <th>Remark 2</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "remarks2")}>{this.state.declarationDetails.remarks2}</td>
                                </tr>
                                <tr>
                                    <th>Remark 3</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "remarks3")}>{this.state.declarationDetails.remarks3}</td>
                                </tr>
                            </table>
                        </div>
                        {/*Supplier Table */}
                        <div className="col-lg-6">
                            <h5><b>Supplier (respondent) Information</b></h5>
                            <table className="material-decalaration-table">
                                <tr>
                                    <th>Company Name</th>
                                    {/* <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "companyName")}>{this.state.declarationDetails.companyName}</td> */}
                                    <div className="autocomplete-wrapper">
                                        <Autocomplete
                                            contentEditable={true}
                                            value={this.state.declarationDetails.companyName}
                                            items={this.state.EquipmentList}
                                            getItemValue={item => item}
                                            shouldItemRender={this.renderMovieTitle.bind(this)}
                                            renderMenu={item => (
                                                <div className="dropdown">
                                                    {item}
                                                </div>)}
                                            renderItem={(item, isHighlighted) =>
                                                <div className={`items ${isHighlighted ? 'selected-items' : ''}`}>
                                                    {item}
                                                </div>}
                                            onChange={(e, field) => this.handleInputChanges(e, "companyName")}
                                            onSelect={value => this.handleSelectChange(value, "companyName")}
                                        /></div>
                                </tr>
                                <tr>
                                    <th>Division Name</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "divisionName")}>{this.state.declarationDetails.divisionName}</td>
                                </tr>
                                <tr>
                                    <th>Address</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "address")}>{this.state.declarationDetails.address}</td>
                                </tr>
                                <tr>
                                    <th>Contact Person</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "contactPerson")}>{this.state.declarationDetails.contactPerson}</td>
                                </tr>
                                <tr>
                                    <th>Telephone Number</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "telephone")}>{this.state.declarationDetails.telephone}</td>
                                </tr>
                                <tr>
                                    <th>Fax Number</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "fax")}>{this.state.declarationDetails.fax}</td>
                                </tr>
                                <tr>
                                    <th>E-mail Address</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "email")}>{this.state.declarationDetails.email}</td>
                                </tr>
                                <tr>
                                    <th>SDoC ID-No.</th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "sdocIdNo")}>{this.state.declarationDetails.sdocIdNo}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {/* Product information Table */}
                        <div className="col-lg-12">
                            <h5><b>Product Information</b></h5>
                            <table className="material-decalaration-table table table-responsive">
                                <tr>
                                    <th rowSpan="2">Product Name</th>
                                    <th rowSpan="2">Product Number</th>
                                    <th colSpan="2">Delivered Unit</th>
                                    <th rowSpan="2">Product Information</th>
                                </tr>
                                <tr>
                                    {/* <th></th>
                                    <th></th> */}
                                    <th>Amount</th>
                                    <th>Unit</th>
                                    {/* <th></th> */}
                                </tr>
                                <tr>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productName")}>{this.state.declarationDetails.productName}</td>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productNumber")}>{this.state.declarationDetails.productNumber}</td>
                                    <td style={{ textAlignLast: "center" }} contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productQuantityAmount")}>{this.state.declarationDetails.productQuantityAmount}</td>
                                    <td className="p-0">
                                        <select className="table-editable-dropdown" value={this.state.declarationDetails.productMetricUnit} onChange={(e) => this.handleInputChange(e, "productMetricUnit")}>
                                            <option value=""></option>
                                            <option value="piece">piece</option>
                                            <option value="kg">kg</option>
                                            <option value="m">m</option>
                                            <option value="m2">m2</option>
                                            <option value="m3">m3</option>
                                            <option value="litre">litre</option>
                                        </select>
                                    </td>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productInfo")}>{this.state.declarationDetails.productInfo}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <h5 className="mt-3"><b>Material Information</b></h5>
                    <div className="row mt-3">
                        {/* materials Table */}
                        <div className="col-lg-7 text-right">
                            <p>This materials information shows the amount of hazardous materials contained in </p>
                        </div>
                        <div className="col-lg-5">
                            <table className="material-decalaration-table">
                                <tr>
                                    <th></th>
                                    <th>Unit</th>
                                </tr>
                                <tr>
                                    <td style={{ textAlignLast: "center" }} contentEditable={true} onBlur={(e) => this.handleInputChange(e, "materialQuantityAmount")}>{this.state.declarationDetails.materialQuantityAmount}</td>
                                    <td className="p-0">
                                        <select className="table-editable-dropdown" value={this.state.declarationDetails.materialMetricUnit} onChange={(e) => this.handleInputChange(e, "materialMetricUnit")}>
                                            <option></option>
                                            <option value="piece">piece</option>
                                            <option value="kg">kg</option>
                                            <option value="m">m</option>
                                            <option value="m2">m2</option>
                                            <option value="m3">m3</option>
                                        </select>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="materialCustomStyle">
                        <div className="row mt-3">
                            {/* Product information Table */}
                            <div className="col-lg-12">
                                <table className="material-decalaration-table table table-responsive">
                                    <tr>
                                        <th rowSpan="2">Table</th>
                                        <th rowSpan="2" colSpan="2">Material Name</th>
                                        <th rowSpan="2">Threshold Level</th>
                                        <th>Present above Threshold Level</th>
                                        <th colSpan="2">If yes, Material Mass</th>
                                        <th rowSpan="2">If yes, information on where it is used</th>
                                    </tr>
                                    <tr>
                                        {/* <th></th>
                                    <th></th> */}
                                        {/* <th></th> */}
                                        <th>Yes/No</th>
                                        <th>Mass</th>
                                        <th>Unit</th>
                                        {/* <th></th> */}
                                    </tr>
                                    <tr>
                                        <td rowSpan="11">Table A**<small>(materials listed in appendix 1 of the Covention)</small></td>
                                        <td colSpan="2">Asbestos</td>
                                        <td>0.1%*</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[0].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 0)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 0)}>{this.state.declarationDetails.materials[0].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[0].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 0)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 0)}>{this.state.declarationDetails.materials[0].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Polychlorinated biphenyls (PCBs)</td>
                                        <td>50 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[1].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 1)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 1)}>{this.state.declarationDetails.materials[1].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[1].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 1)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 1)}>{this.state.declarationDetails.materials[1].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td rowSpan="9">Ozone depleting substance</td>
                                        <td >Chlorofluorocarbons (CFCs)</td>
                                        <td rowSpan="9">no threshold level</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[2].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 2)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 2)}>{this.state.declarationDetails.materials[2].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[2].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 2)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 2)}>{this.state.declarationDetails.materials[2].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Halons</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[3].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 3)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 3)}>{this.state.declarationDetails.materials[3].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[3].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 3)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 3)}>{this.state.declarationDetails.materials[3].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Other fully halogenated CFCs</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[4].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 4)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 4)}>{this.state.declarationDetails.materials[4].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[4].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 4)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 4)}>{this.state.declarationDetails.materials[4].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Carbon tetrachloride</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[5].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 5)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 5)}>{this.state.declarationDetails.materials[5].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[5].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 5)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 5)}>{this.state.declarationDetails.materials[5].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>1,1,1-Trichloroethane</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[6].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 6)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 6)}>{this.state.declarationDetails.materials[6].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[6].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 6)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 6)}>{this.state.declarationDetails.materials[6].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Hydrochlorofluorocarbons</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[7].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 7)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 7)}>{this.state.declarationDetails.materials[7].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[7].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 7)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 7)}>{this.state.declarationDetails.materials[7].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Hydrobromofluorocarbons</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[8].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 8)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 8)}>{this.state.declarationDetails.materials[8].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[8].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 8)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 8)}>{this.state.declarationDetails.materials[8].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Methyl bromide</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[9].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 9)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 9)}>{this.state.declarationDetails.materials[9].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[9].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 9)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 9)}>{this.state.declarationDetails.materials[9].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td>Bromochloromethane</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[10].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 10)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 10)}>{this.state.declarationDetails.materials[10].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[10].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 10)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 10)}>{this.state.declarationDetails.materials[10].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td rowSpan="2">A-4</td>
                                        <td colSpan="2">Anti-fouling systems containing organotin compounds as a biocide</td>
                                        <td>2,500 mg total tin/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[11].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 11)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 11)}>{this.state.declarationDetails.materials[11].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[11].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 11)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 11)}>{this.state.declarationDetails.materials[11].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Anti-fouling systems containing cybutryne</td>
                                        <td>1000 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[22].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 22)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 22)}>{this.state.declarationDetails.materials[22].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[22].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 22)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 22)}>{this.state.declarationDetails.materials[22].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td rowSpan="9">Table B**<small>(materials listed in appendix 2 of the Covention)</small></td>
                                        <td colSpan="2">Cadmium and Cadmium Compounds</td>
                                        <td>100 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[12].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 12)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 12)}>{this.state.declarationDetails.materials[12].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[12].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 12)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 12)}>{this.state.declarationDetails.materials[12].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Hexavalent Chromium and Hexavalent Chromium Compounds</td>
                                        <td>1,000 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[13].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 13)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 13)}>{this.state.declarationDetails.materials[13].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[13].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 13)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 13)}>{this.state.declarationDetails.materials[13].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Lead and Lead Compounds</td>
                                        <td>1,000 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[14].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 14)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 14)}>{this.state.declarationDetails.materials[14].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[14].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 14)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 14)}>{this.state.declarationDetails.materials[14].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Mercury and Mercury Compounds</td>
                                        <td>1,000 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[15].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 15)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 15)}>{this.state.declarationDetails.materials[15].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[15].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 15)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 15)}>{this.state.declarationDetails.materials[15].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Polybrominated Biphenyl (PBBs)</td>
                                        <td>50 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[16].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 16)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 16)}>{this.state.declarationDetails.materials[16].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[16].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 16)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 16)}>{this.state.declarationDetails.materials[16].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Polybrominated Dephenyl Ethers (PBDEs)</td>
                                        <td>1,000 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[17].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 17)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 17)}>{this.state.declarationDetails.materials[17].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[17].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 17)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 17)}>{this.state.declarationDetails.materials[17].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Polychloronaphthalanes (more than 3 chlorine atoms)</td>
                                        <td>50 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[18].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 18)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 18)}>{this.state.declarationDetails.materials[18].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[18].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 18)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 18)}>{this.state.declarationDetails.materials[18].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Radioactive Substances</td>
                                        <td>no threshold level</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[19].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 19)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 19)}>{this.state.declarationDetails.materials[19].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[19].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 19)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 19)}>{this.state.declarationDetails.materials[19].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Certain Shortchain Chlorinated Paraffins (Alkanes, C10-C13, chloro)</td>
                                        <td>1%</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[20].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 20)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 20)}>{this.state.declarationDetails.materials[20].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[20].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 20)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 20)}>{this.state.declarationDetails.materials[20].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td rowSpan="2">Annex II**<small>(Additional materials)</small></td>
                                        <td colSpan="2">Perfluorooctane sulfonic acid (PFOs)</td>
                                        <td>10 mg/kg***</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[21].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 21)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 21)}>{this.state.declarationDetails.materials[21].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[21].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 21)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 21)}>{this.state.declarationDetails.materials[21].informationOnUsage}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">Brominated Flame Retardant (HBCDD)</td>
                                        <td>100 mg/kg</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[22].isContainAboveThreshold} onChange={(e) => this.handleMaterialInputChange(e, "isContainAboveThreshold", 22)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "mass", 22)}>{this.state.declarationDetails.materials[22].mass}</td>
                                        <td className="p-0">
                                            <select className="table-editable-dropdown" value={this.state.declarationDetails.materials[22].unit} onChange={(e) => this.handleMaterialInputChange(e, "unit", 22)}>
                                                <option></option>
                                                <option value="kg">kg</option>
                                                <option value="g">g</option>
                                                <option value="mg">mg</option>
                                            </select>
                                        </td>
                                        <td contentEditable={true} onBlur={(e) => this.handleMaterialInputChange(e, "informationOnUsage", 22)}>{this.state.declarationDetails.materials[22].informationOnUsage}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {/* Update MD & SDoc */}
                        <div className="col-md-12 col-sm-12">
                            <h5 className="mb-0"><b> Update MD & SDoC</b></h5>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <label className="form-label">MD </label><br></br>
                            < div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Choose file<input type="file" id="files" className="form-control" name="MDoc" onChange={e => this.onHandleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                                </div>
                                <input type="text" className="form-control" placeholder="No file chosen" value={this.state.declarationDetails.mdAttachmentName} />
                                {this.state.declarationDetails.mdAttachmentName && 
                                    <div className="input-group-append" style={{ zIndex: "1", cursor: "pointer" }}>
                                        <i className="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearMDoc()}></i>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <label className="form-label">SDoc </label><br></br>

                            {/* <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Choose file<input type="file" id="files" className="form-control" name="SDoc" onChange={e => this.onHandleInputChange(e)} onClick={(event) => { event.currentTarget.value = null }} /></span>
                                </div>
                                <input type="text" className="form-control" placeholder="No file chosen" value={this.state.declarationDetails.sDocAttachmentName} />
                                <div className="input-group-append" style={{ zIndex: "1" }}>
                                    <i className="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearSDoc()}></i>
                                </div>
                            </div> */}

                            <div
                                className="autocomplete-wrapper"
                                style={{ zIndex: 9999 }}
                            >
                                <Autocomplete
                                    value={this.state.declarationDetails.sDocAttachmentName}
                                    inputProps={{
                                        placeholder: "Select SDoC",
                                    }}
                                    renderInput={(props) => {
                                        return (
                                            <input
                                                className="form-control"
                                                id="exampleFormControlInput1"
                                                {...props}
                                            />
                                        );
                                    }}
                                    items={SDocCompanyList ?? []}
                                    getItemValue={(item) => item?.attachmentName}
                                    shouldItemRender={this.renderattachmentNameTitle.bind(
                                        this
                                    )}
                                    renderMenu={(item) => (
                                        <div className="dropdowns">{item}</div>
                                    )}
                                    renderItem={(item, isHighlighted) => (
                                        <div
                                            className={`items ${isHighlighted ? "selected-items" : ""
                                                }`}
                                        >
                                            {item?.attachmentName}
                                        </div>
                                    )}
                                    onChange={(e) => this.handleAnnualSearchChange(e)}
                                    onSelect={(e, item) => this.handleAnnualSelectChange(e, item)}
                                />
                            </div>
                        </div>
                        {/* <div className="col-md-6 col-sm-6">
                            <label className="form-label">IHM Presense</label><br></br>
                            <div class="row">
                                <div className="col-sm-12 col-md-12">
                                    <span className="mr-4">
                                        <input type="radio" name="ihmPresenseYes" checked={this.state.ihmPresenseYes} onChange={e => this.onHandleRadioInputChange(e)} />
                                        <span className="ml-1">Yes</span>
                                    </span>
                                    <span className="mr-4">
                                        <input type="radio" name="ihmPresenseNo" checked={this.state.ihmPresenseNo} onChange={e => this.onHandleRadioInputChange(e)} />
                                        <span className="ml-1">No</span>
                                    </span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className={"col-lg-12 mt-4"}>
                            <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                < button
                                    disabled={!this.state.declarationDetails.mdAttachmentName}
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    type="submit" onClick={() => this.AddMaterialDeclaration()}>
                                    Submit
                                </button>
                                <button
                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                    type="button" onClick={() => this.CancelMaterialDeclaration()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        MDocAttachment: state.MMPLDashboardReducer.MDocAttachment,
        SDocAttachment: state.MMPLDashboardReducer.SDocAttachment,
        PODetail: state.POViewReducer.PODetail,
        POLineItem: state.POViewReducer.POLineItem,
        MDSDocCollectAll: state.SidePanReducer.MDSDocCollectAll,
        isInPoValidation: state.SidePanReducer.isInPoValidation,
        CompanyList: state.MMPLDashboardReducer.CompanyList,
        SDocCompanyList: state.MMPLDashboardReducer.SDocCompanyList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MaterialDeclarationCollect)
);
